import { theme } from 'styled-tools'

import { styled } from '@creditas/stylitas'
import { TableBody } from '@creditas/table'

const CustomBody = styled(TableBody)`
  tr:hover {
    outline: 1px solid ${theme('bColorsecondary05')};
    box-shadow: 0 10px 25px 0 ${theme('bColorneutral05')};
  }
`

export { CustomBody as TableBody }
